import { CALENDAR_SUBSCRIBE } from 'permissions/actions'

export const CALENDAR = '@@permissions/calendar/policy'

export default {
  [CALENDAR_SUBSCRIBE]: user => !user.read_only
}
